import { Icon } from '@toggle/design-system';
import clsx from 'clsx';
import React, { CSSProperties, SyntheticEvent, useState } from 'react';

import styles from './TrustedSourceIcon.module.scss';

export interface TrustedSourceIconProps {
  className?: string;
  faviconUrl: string;
  size: number;
  variant: 'circular' | 'square';
}

export const TrustedSourceIcon = ({
  className,
  faviconUrl,
  size,
  variant,
}: TrustedSourceIconProps) => {
  const [loadedFaviconUrl, setLoadedFaviconUrl] = useState<string>();
  const [failedFaviconUrl, setFailedFaviconUrl] = useState<string>();
  const sizeStyle: CSSProperties = { height: size, width: size };
  const hasLoaded = loadedFaviconUrl === faviconUrl;
  const hasFailed = failedFaviconUrl === faviconUrl;

  const handleFaviconLoad = (event: SyntheticEvent<HTMLImageElement>) => {
    setLoadedFaviconUrl(event.currentTarget.getAttribute('src') ?? undefined);
    setFailedFaviconUrl(undefined);
  };

  const handleFaviconError = (event: SyntheticEvent<HTMLImageElement>) => {
    setLoadedFaviconUrl(undefined);
    setFailedFaviconUrl(event.currentTarget.getAttribute('src') ?? undefined);
  };

  return (
    <span
      aria-hidden="true"
      className={clsx(styles.root, className)}
      data-testid="trusted-source-icon"
      style={sizeStyle}
    >
      {!hasLoaded && <Icon iconName="Globe" size={Math.ceil((size * 2) / 3)} />}
      {!hasFailed && (
        <img
          alt=""
          className={clsx(
            styles.favicon,
            styles[variant],
            !hasLoaded && styles.hidden
          )}
          hidden={!hasLoaded}
          key={faviconUrl}
          onError={handleFaviconError}
          onLoad={handleFaviconLoad}
          src={faviconUrl}
        />
      )}
    </span>
  );
};
